import { Injectable } from "@angular/core";
import { UpgradeModule } from "@angular/upgrade/static";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  modal;

  constructor(private upgrade: UpgradeModule) {
    this.modal = this.upgrade.injector.get("UibModalInjectable");
  }

  open(template): void {
    this.modal.open(template);
  }
}
